module.exports = __webpack_public_path__ + "assets/img/save-history-icon-delete.ffda3db6.svg";